import { Injectable } from '@angular/core';
import { FetchMarginData, FilterData, SaveMarginData } from '../models/margin-modal';

@Injectable({
    providedIn: 'root'
})

export class MarginCalcStoreService {
    saveMarginData : SaveMarginData[] = [];
    filterData: FilterData;
    gridId: number;
    constructor() {
        this.saveMarginData = [];
        this.filterData = {
            Passcode : '',
            SelectedMarket: '',
            SelectedAccountname: '',
            SelectedRequestedBy: '',
            Offshore_Billable_Hrs: 0,
            Onsite_Billable_Hrs: 0
        }
        this.gridId = 0;
    }
}